import Auth from 'j-toker';
import { apiPost, apiPut, apiDelete, apiGet } from 'helpers/ApiHelper';

const makeUrl = (path) => Auth.getApiUrl() + '/landlords/fees' + path;

const buildFormData = (data) => {
  return {
    // Rails accepts_nested_attributes_for expects `*_attributes` param
    fee_template: { ...data, fee_events_attributes: data.fee_events },
  };
};

export function getFeeTemplates() {
  return apiGet(makeUrl('/fee_templates'));
}

export function getChargeCodes() {
  return apiGet(Auth.getApiUrl() + '/landlords/charge_codes');
}

export function getAssociations() {
  return apiGet(Auth.getApiUrl() + '/landlords/associations');
}

export function createFeeTemplate(data) {
  const submitData = buildFormData(data);
  return apiPost(makeUrl('/fee_templates'), submitData);
}

export function updateFeeTemplate(data, feeTemplateId) {
  const submitData = buildFormData(data);

  return apiPut(makeUrl(`/fee_templates/${feeTemplateId}`), submitData);
}

export function deleteFeeTemplate(feeTemplateId) {
  return apiDelete(makeUrl(`/fee_templates/${feeTemplateId}`));
}

export function getIncentiveTemplates() {
  return apiGet(Auth.getApiUrl() + '/landlords/incentives/incentive_templates');
}

export function createIncentiveTemplate(data) {
  return apiPost(Auth.getApiUrl() + '/landlords/incentives/incentive_templates', data);
}

export function updateIncentiveTemplate(data) {
  return apiPut(Auth.getApiUrl() + `/landlords/incentives/incentive_templates/${data.id}`, data);
}

export function deleteIncentiveTemplate(incentiveTemplateId) {
  return apiDelete(
    Auth.getApiUrl() + `/landlords/incentives/incentive_templates/${incentiveTemplateId}`
  );
}

export function getIncentiveTemplateHistory(incentiveTemplateId) {
  return apiGet(
    Auth.getApiUrl() + `/landlords/incentives/incentive_templates/${incentiveTemplateId}/history`
  );
}

export function getFeeTemplateHistory(feeTemplateId) {
  return apiGet(Auth.getApiUrl() + `/landlords/fees/fee_templates/${feeTemplateId}/history`);
}
